module.exports = __webpack_public_path__ + "static/img/pin-landing-rate-active.8f78e74.svg";